"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncrementDecrementWrapper = exports.Counter = exports.Wrapper = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.Wrapper = (0, flora_react_1.styled)(flora_react_1.Flex, {
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    padding: 'calc($3 - 1px)',
    border: '1px solid $nonInteractiveAuxiliar',
    borderRadius: '$small',
});
exports.Counter = (0, flora_react_1.styled)('p', {
    minWidth: '16px',
    textAlign: 'center',
    margin: '0 $2',
    color: '$nonInteractiveAuxiliar',
});
exports.IncrementDecrementWrapper = (0, flora_react_1.styled)('span', {
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    svg: {
        background: 'transparent',
        borderRadius: '$pill',
    },
    variants: {
        disable: {
            true: {
                svg: {
                    color: '$nonInteractivePredominant',
                    border: '2px solid $nonInteractivePredominant',
                },
            },
        },
        type: {
            decrement: {
                svg: {
                    color: '$nonInteractiveAuxiliar',
                    border: '2px solid $nonInteractiveAuxiliar',
                },
            },
            increment: {
                svg: {
                    color: '$actionableDefault',
                    border: '2px solid $actionableDefault',
                },
            },
        },
    },
});
